const state = {

    CategoryList : []
    
  }
  
  const mutations = {
    SetCategoryList(state, payload){
        state.CategoryList = payload
    },
    SetIndividualCategory(state, payload){
        state.CategoryList.push(payload)
    },
    UpdateIndividualCategory(state, payload){

        let index = state['CategoryList'].findIndex(x => x["_id"] == payload["_id"])
        state['CategoryList'].splice(index,1,payload)
    },
    DeleteIndividualCategory(state, payload){

        let index = state['CategoryList'].findIndex(x => x["_id"] == payload["_id"])
        state['CategoryList'].splice(index,1)
    },
    DeleteMultipleCategory(state, payload){

        payload.forEach(element => {
            let index = state['CategoryList'].findIndex(x => x["_id"] == element)
            state['CategoryList'].splice(index,1)
        });
    }
  }
  
  const actions = {
    
  }
  
  const getters = {

    GetCategoryList(state){

        return state.CategoryList
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  